import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Button from "./Button";
import Collapsible from 'react-collapsible';
import { collapsibleSettings } from '../../helpers/Helpers';

class TemplateField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            templates: [],
            templateText: '',
            templateTitle: '',
            edit: false,
            editIndex: null
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                templates: value
            });
        }
    }

    save() {
        const {templateText, templateTitle, templates, edit, editIndex} = this.state;

        if (templateText !== '' && templateTitle !== '') {
            let newTemplates = templates ? templates : [];

            if (edit && editIndex !== null) {
                newTemplates[editIndex].title = templateTitle;
                newTemplates[editIndex].text = templateText;
            } else {
                newTemplates.push(
                    {
                        title: templateTitle,
                        text: templateText
                    }
                );
            }

            this.setState({
                templates: newTemplates,
                modal: false,
                edit: false,
                editIndex: null
            }, () => this.props.input.value !== '' ? this.props.change(null, templates) : this.props.input.onChange(templates));
        }
    }

    showModal() {
        this.setState({
            modal: true
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    edit(template, index) {
        this.setState({
            edit: true,
            editIndex: index,
            templateTitle: template.title,
            templateText: template.text
        }, () => this.showModal());
    }

    remove(index) {
        const {templates} = this.state;

        let newTemplates = templates;
        newTemplates.splice(index, 1);

        this.setState({
            templates: newTemplates
        }, () => this.props.change(this.props.name, templates));
    }

    render() {
        const {modal, templates, templateTitle, templateText, edit} = this.state;
        const {label, meta: {touched, error}, expanded} = this.props;

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={<label className={classNamesPrefixed({"trigger__label":true})}>{label ? label : 'Template'}</label>}
                open={expanded}
            >
                <Modal
                    showModal={modal}
                    onClose={() => {
                        this.hideModal();
                    }}
                    title={edit ? "Edit" : "Add a template"}
                    icon="bars"
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <Button
                                buttonStyle="btn-primary btn-save"
                                title="Save"
                                icon={"save"}
                                onClick={(e) => {
                                    e.preventDefault();

                                    this.save();
                                }}
                            />
                        </div>
                    }
                >
                    <div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <label htmlFor="template_title">Template title</label>
                            <input
                                type="text"
                                id="template_title"
                                name="template_title"
                                value={templateTitle}
                                onChange={(e) => {
                                    this.setState({
                                        templateTitle: e.target.value
                                    });
                                }}
                            />
                        </div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <label htmlFor="template_title">Template Text</label>
                            <textarea
                                type="text"
                                id="template_text"
                                name="template_text"
                                value={templateText}
                                onChange={(e) => {
                                    this.setState({
                                        templateText: e.target.value
                                    });
                                }}
                            />
                        </div>
                        <br/>
                    </div>
                </Modal>
                <p>
                    <i
                        className={classNamesPrefixed({
                            'grey-color': true
                        })}
                    >Add a template.</i>
                </p>

                    <div>
                        <ul
                            className={classNamesPrefixed({
                                'grey-color': true,
                                'default-list': true
                            })}
                        >
                            {templates.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <i>{item.title}</i>
                                        <a onClick={() => this.remove(index)}><Icon name='trash'/>Remove</a>
                                        <a onClick={() => this.edit(item, index)}><Icon name='pencil'/>Edit</a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div
                        className={classNamesPrefixed({
                            'form-actions': true
                        })}
                    >
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    templateTitle: '',
                                    templateText: '',
                                    edit: false
                                }, () => this.showModal());
                            }}
                        >
                            Add template
                        </button>
                    </div>
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
            </Collapsible>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateField)


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/TemplateField.js